import React, { useEffect, useState } from "react";
import Circlebtn from "../components/Circlebtn";
import PrimaryButton from "../components/PrimaryButton";
import user from "../assets/images/user.png";
import fb from "../assets/icons/facebook.svg";
import insta from "../assets/icons/insta.svg";
import yt from "../assets/icons/YT.svg";
import SpecificAccountCard from "../components/SpecificAccountCard";
import ScheduledPostCard from "../components/ScheduledPostCard";
import DotMenu from "../components/DotMenu";
import { PiCirclesThree } from "react-icons/pi";
import { MdOutlineManageAccounts } from "react-icons/md";
import { PiTrashLight } from "react-icons/pi";
import MainModal from "../components/MainModal";
import AddAccount, { ChooseGroup } from "../components/AddAccount";
import SelectVoice from "../components/SelectVoice";
import { PlusIcon, RightArrowIcon } from "../assets/icons/Icons";
import { useLocation } from "react-router-dom";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import { CardProfileSkeletonLoader, CardSkeletonLoader } from "../components/CardSkeletonLoader";



const Accounts = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 500);
  }, []);
  return (
    <div className="mt-5">
      <p className="text-[#9392A2] text-xs font-medium">5 accounts</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
          [...Array(6)].map((_, index) => <CardProfileSkeletonLoader key={index} />) :
          [...Array(6)].map((_, index) => <SpecificAccountCard key={index} />)
        }
      </div>
    </div>
  );
}
const Schedules = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 500);
  }, []);
  return (
    <div className="mt-5">
      <p className="text-[#9392A2] text-xs font-medium">3 posts scheduled</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
          [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
          [...Array(6)].map((_, index) => <ScheduledPostCard key={index} />)
        }
      </div>
    </div>
  );
}
const Information = () => {
  return (
    <div className="mt-5">
      <div className="flex items-center gap-2">
        <div className="flex items-center justify-center gap-[6px] w-[110px] h-[34px] rounded-3xl bg-white">
          <img src={insta} className="w-4 h-4 rounded-full" alt="social logo" />
          <p className="text-[#0F0C18] text-sm font-medium">Instagram</p>
        </div>
        <div className="flex items-center justify-center gap-[6px] w-[110px] h-[34px] rounded-3xl border border-[#CDCCD7]">
          <img src={yt} className="w-4 h-4 rounded-full" alt="social logo" />
          <p className="text-[#0F0C18] text-sm font-medium">Youtube</p>
        </div>
      </div>
      <div className="mt-6 flex gap-2 flex-wrap">
        <div className="w-[379px]">
          <p className="text-[#9392A2] text-xs font-medium mb-3">Description</p>
          <div className="h-[140px] bg-white rounded-xl p-4">
            <p className="text-[#0F0C18] text-base font-medium tracking-tight">Single description</p>
            <p className="text-[#9392A2] text-xs font-medium leading-[18px] tracking-tight mt-1">In this section you can provide single<br />description for all social networks in the group</p>
            <PrimaryButton label="Update description" black className="rounded-full inline-block px-4 py-1.5 mt-3.5" labelStyle="text-sm font-medium" />
          </div>
        </div>
        <div className="w-[379px]">
          <p className="text-[#9392A2] text-xs font-medium mb-3">Profiles under social network</p>
          <div className="bg-white rounded-xl p-4">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <img src={user} className="w-4 h-4 rounded-full" alt="user" />
                <p className="text-[#0F0C18] text-sm font-medium tracking-tight">@andrew_wack</p>
              </div>
              <p className="text-[#9392A2] text-sm font-medium tracking-tight">102,456 followers</p>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <img src={user} className="w-4 h-4 rounded-full" alt="user" />
                <p className="text-[#0F0C18] text-sm font-medium tracking-tight">@andrew_wack_sp</p>
              </div>
              <p className="text-[#9392A2] text-sm font-medium tracking-tight">72,456 followers</p>
            </div>
          </div>
        </div>
        <div className="w-[379px]">
          <p className="text-[#9392A2] text-xs font-medium mb-3">General information</p>
          <div className="bg-white rounded-xl p-4">
            <div className="flex items-center justify-between mb-2">
              <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Date of group creation</p>
              <p className="text-[#9392A2] text-sm font-medium tracking-tight">24.09.2020</p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-[#0F0C18] text-sm font-medium tracking-tight">Location</p>
              <p className="text-[#9392A2] text-sm font-medium tracking-tight">New York, United States</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const options = [
  { label: 'Manage accounts', icon: PiCirclesThree },
  { label: 'Manage access', icon: MdOutlineManageAccounts },
  { label: 'Delete group', icon: PiTrashLight, color: "red" },
];

const SpecificGroup = () => {
  const [pageIndex, setPageIndex] = useState<number>(1);
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);
  const [showVoiceModal, setShowVoiceModal] = useState<boolean>(false);
  const [showChooseGroup, setShowChooseGroup] = useState<boolean>(false);
  const location = useLocation();
  const redirect = useRedirect();

  useEffect(() => {
    if (!location.hash) {
      redirect("#accounts");
    } else if (location.hash === "#accounts") {
      setPageIndex(1);
    } else if (location.hash === "#schedules") {
      setPageIndex(2);
    } else if (location.hash === "#information") {
      setPageIndex(3);
    }
  }, [location.hash, redirect]);

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[7px]">
          <h1 onClick={() => redirect(pathnames.accounts)} className="text-[#9392A2] cursor-pointer text-xs font-medium tracking-tight">Accounts</h1>
          <RightArrowIcon />
          <h1 className="text-[#9392A2] text-xs cursor-pointer font-medium tracking-tight">Andrew Wack</h1>
        </div>
        <div className="flex items-center gap-2">
          {/* show voice modal just for testing */}
          <PrimaryButton onClick={() => setShowVoiceModal(!showVoiceModal)} label="Schedule multipost" className="rounded-full px-4 py-1.5" labelStyle="text-sm font-medium" />
          <div onClick={() => setShowAccountModal(true)}>
            <Circlebtn icon={<PlusIcon />} className="w-8 h-8 bg-white" />
          </div>
          <DotMenu options={options} type="circle" />
        </div>
      </div>
      <div className="mt-3.5 flex items-center gap-3.5">
        <img src={user} className="w-14 h-14 rounded-full" alt="user" />
        <div>
          <h1 className="text-[#0F0C18] text-[27px] font-medium tracking-tight">Andrew Wack</h1>
          <h1 className="text-[#9392A2] text-xs font-medium">Group of 3 accounts</h1>
        </div>
      </div>
      <p className="text-[#9392A2] mt-8 text-xs font-medium tracking-tight">Statistics</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">3</h1>
          <div className="flex items-center justify-between">
            <p className="text-[#9392A2] text-xs font-medium tracking-tight">Social networks</p>
            <div className="flex items-center gap-1">
              <img src={fb} className="w-4 h-4 rounded-full" alt="social icon" />
              <img src={insta} className="w-4 h-4 rounded-full" alt="social icon" />
              <img src={yt} className="w-4 h-4 rounded-full" alt="social icon" />
            </div>
          </div>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">15,557</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Total followers</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">3</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts scheduled</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">132</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Posts published</p>
        </div>
      </div>
      <div className="mt-8">
        <div className="flex items-center gap-[21px]">
          <p onClick={() => {
            setPageIndex(1)
            redirect("#accounts")

          }} className={`${pageIndex === 1 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer select-none`}>Accounts</p>
          <p onClick={() => {
            setPageIndex(2)
            redirect("#schedules")

          }} className={`${pageIndex === 2 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer select-none`}>Schedules</p>
          <p onClick={() => {
            setPageIndex(3)
            redirect("#information")

          }} className={`${pageIndex === 3 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer select-none`}>Information</p>
        </div>
        <div className="w-full h-[1px] bg-[#CDCCD7] -mt-[1.5px]" />
      </div>
      {
        pageIndex === 1 && <Accounts />
      }
      {
        pageIndex === 2 && <Schedules />
      }
      {
        pageIndex === 3 && <Information />
      }
      {
        showAccountModal && 
        <MainModal
          subLabel="Step 1 of 3"
          setShowModal={setShowAccountModal}
        >
          <AddAccount showNext={() => {
            setShowAccountModal(false);
            setShowChooseGroup(true);
          }} />
        </MainModal>  
      }
      {
        showChooseGroup && 
        <MainModal
          subLabel="Step 2 of 3"
          setShowModal={setShowChooseGroup}
        >
          <ChooseGroup
            showPrev={() => {
          setShowChooseGroup(false);
          setShowAccountModal(true);
          }}
          showNext={() => {
            setShowChooseGroup(false);
            setShowVoiceModal(true);
          }}
          />
        </MainModal>  
      }
      {
        showVoiceModal &&
        <MainModal
          label="Select voice"
          setShowModal={setShowVoiceModal}
        >
          <SelectVoice />
        </MainModal>
      }
    </>
  );
};

export default SpecificGroup;